<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2022-11-15 14:51:10
 * @LastEditors: xiawenlong
 * @LastEditTime: 2022-11-25 10:48:36
-->
<template>
  <div class="teacher">
    <div class="title">
      配置监考老师
      <el-button
        v-if="!isReadOnly"
        icon="el-icon-circle-plus-outline"
        type="primary"
        @click="toAdd"
      >
        增加
      </el-button>
    </div>
    <div class="teacher-table">
      <table-list
        :loading="loading"
        :data="teacherList"
        :columns="columns(this)"
        :operates="operates(this)"
        :options="{ operatesWidth: 120 }"
      ></table-list>
    </div>
    <AddFromUser ref="AddFromUser" @success="getTeacherList" />
  </div>
</template>
<script>
// 表格列配置
const columns = () => [
  {
    prop: 'userName',
    label: '姓名',
    minWidth: 80,
  },
  {
    prop: 'phone',
    label: '手机号',
    minWidth: 120,
  },
  {
    prop: 'idCard',
    label: '身份证',
    minWidth: 170,
  },
  {
    prop: 'createTime',
    label: '添加时间',
    minWidth: 150,
  },
]
// 表格操作按钮配置
const operates = _this => [
  {
    method: _this.handleDelete,
    label: '删除',
    isShow: () => !_this.isReadOnly,
  },
]
import TableList from '@/components/TableList'
import AddFromUser from './AddFromUser'
import { teacherList, userTeacherDelete } from '@/api/exam'
import to from 'await-to'
export default {
  name: 'Teacher',
  components: { TableList, AddFromUser },
  props: {
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      teacherList: [],
      columns,
      operates,
      fileList: [],
    }
  },
  mounted() {
    this.getTeacherList()
  },
  methods: {
    async getTeacherList() {
      const [res, err] = await to(
        teacherList({ ...this.queryParams, planId: this.$route.params.id }),
      )
      if (err) return this.$message.warning(err.msg)
      this.teacherList = res.data
    },
    toAdd() {
      this.$refs.AddFromUser.show()
    },
    // 删除
    async handleDelete(row) {
      this.$confirm('你确认要删除吗?', '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [, err] = await to(
            userTeacherDelete({
              relationIds: [row.id],
            }),
          )
          if (err) return this.$message.warning(err.msg)
          this.$message.success('删除成功')
          this.getTeacherList()
        })
        .catch(() => {})
    },
  },
}
</script>
<style lang="scss" scoped>
.teacher {
  height: 100%;
  .title {
    height: 78px;
    line-height: 78px;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    border-bottom: 1px solid #e8ebf2;
    padding: 0 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .el-button {
      width: 80px;
      height: 36px;
      background: #3671bf;
      border-radius: 2px;
    }
  }
  .userImport {
    padding: 20px 20px 0 20px;
    display: flex;
    .el-button {
      width: auto;
      height: 36px;
      padding: 0 12px;
      margin: 0;
      margin-right: 16px;
    }
    > .el-button {
      padding: 0;
    }
  }
  .teacher-table {
    padding: 20px;
    height: calc(100% - 164px);
    /deep/.table-list {
      .form {
        padding: 0;
        .el-input {
          input {
            padding-right: 12px;
          }
        }
      }
    }
  }
}
</style>
